import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { updateGeo } from 'shared/slices/jsonQuery';
import { ILocation } from 'shared/types/location';
import { TThunkAction } from 'shared/types/redux';
import { addLocationToJsonQuery } from 'shared/utils/jsonQuery/addLocationToJsonQuery';

export const updateGeoLocation =
  (location: ILocation): TThunkAction =>
  (dispatch, getState) => {
    const jsonQuery = selectJsonQuery(getState());

    const nextGeo = addLocationToJsonQuery(jsonQuery, location);

    dispatch(updateGeo(nextGeo));
  };
